import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import {
  Container, Box, AppBar, Typography, Link, Breadcrumbs, Chip, Tabs, Tab, Snackbar, Slide, IconButton, Grid,
  // Button, tabsClasses, Fade, ListItemIcon, CircularProgress, Dialog, DialogTitle, DialogContent, TextField, DialogActions
} from '@mui/material';
import { useRouter } from 'next/router';
import { dataConstants } from '../../src/constants';
import { withProtected } from '../../src/hook/route';
import getPageMetaTags from '../../lib/meta/_getMetaTags';
import { styled } from '@mui/material/styles';
// import PlaylistAddCheckRoundedIcon from '@mui/icons-material/PlaylistAddCheckRounded';
// import { TabContext, TabPanel } from "@mui/lab";
// import SwipeableViews from "react-swipeable-views";
import { useTheme } from '@mui/material/styles';
import useAuth from "../../src/hook/auth";
import getWatchlist from "../../lib/watchlist/_getWatchlist";
// import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import IconButton from '@mui/material/IconButton';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
// import EditRoundedIcon from '@mui/icons-material/EditRounded';
// import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import deleteWatchlist from "../../lib/watchlist/_deleteWatchlist";
import getStockTabs from "../../lib/stock/_getStockTabsData";
import WatchlistTable from "../../src/components/Watchlist";
// import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import addToWatchlist from "../../lib/watchlist/_addToWatchlist";
import AddNewWatchlist from "../../src/components/Watchlist/AddNewWatchlist";
// import { getRandomStr } from "../../src/helpers";
import UserWatchlists from "../../src/components/Watchlist/UserWatchlists";
import getUserWatchlist from "../../lib/watchlist/_getUserWatchlist";
import { needPremium } from "../../src/needPremium";
// import SwipeableEdgeDrawer from "../../src/components/_common/SwipeableDrawer";
const SwipeableEdgeDrawer = dynamic(() => import('../../src/components/_common/SwipeableDrawer'))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// const mainHeadCols = [
//   { "name": "", "colSpan": "3", "includeCols": ["ticker", "shortName", "PRICE"] },
//   { "name": "Fundamentals", "colSpan": "2", "includeCols": ["MKTCAP", "REV_TTM"] },
//   { "name": "Returns", "colSpan": "2", "includeCols": ["PCHG__180", "RETURNS__1095"] },
//   { "name": "Valuation", "colSpan": "3", "includeCols": ["PE", "PS", "MKTEBT"] },
//   { "name": "Growth", "colSpan": "3", "includeCols": ["ROE", "REV_TTM__PCHG_1Y", "NETINC_TTM__PCHG_1Y"] },
//   { "name": "Income Statement", "colSpan": "0", "includeCols": [] },
//   { "name": "Balance Sheet", "colSpan": "0", "includeCols": [] },
//   { "name": "Cashflow Statement", "colSpan": "0", "includeCols": [] },
//   { "name": "Statistics", "colSpan": "0", "includeCols": [] },
//   { "name": "Operations", "colSpan": "0", "includeCols": [] },
//   { "name": "", "colSpan": "1", "includeCols": ["delete"] }
// ]

const mainHeadCols = [
  { "name": "", "colSpan": "3", "includeCols": ["ticker", "shortName"] },
  { "name": "Fundamentals", "colSpan": "2", "includeCols": ["MKTCAP", "REV_TTM"] },
  { "name": "Returns", "colSpan": "2", "includeCols": ["PCHG__180"] },
  { "name": "Valuation", "colSpan": "3", "includeCols": ["PE", "PS", "MKTEBT"] },
  { "name": "Growth", "colSpan": "3", "includeCols": ["ROE", "REV_TTM__PCHG_1Y", "NETINC_TTM__PCHG_1Y"] },
  { "name": "Income Statement", "colSpan": "0", "includeCols": [] },
  { "name": "Balance Sheet", "colSpan": "0", "includeCols": [] },
  { "name": "Cashflow Statement", "colSpan": "0", "includeCols": [] },
  { "name": "Statistics", "colSpan": "0", "includeCols": [] },
  { "name": "Operations", "colSpan": "0", "includeCols": [] },
  { "name": "", "colSpan": "1", "includeCols": ["delete"] }
]

const cols = [
  // { "name": "Ticker", "field": "ticker", "urlField": "ticker", "isPremium": "Premium" },
  // { "name": "Name", "field": "name", "class": "td-color", "urlField": "ticker", "isPremium": "Premium" },
  // { "label": "Price", "name": "Price", "field": "PRICE", "class": "text-center", "isSectorValue": "true", "tooltip": "Price" },
  { "label": "Fundamentals", "name": "Market Cap", "field": "MKTCAP", "class": "sorted", "isSectorValue": true, "isPct": false, "mult": 1, "tooltip": "Market Capital" },
  { "label": "Income Statement", "name": "Revenues TTM", "field": "REV_TTM", "class": "text-right", "isSectorValue": true, "isPct": false, "mult": 1, "tooltip": "Net sales" },
  { "label": "Returns", "name": "6M Pct", "field": "PCHG__180", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 100, "tooltip": "6-Months Stock Price Percent Change" },
  { "label": "Valuation", "name": "PE", "field": "PE", "class": "text-right", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Price to Earnings Ratio" },
  { "label": "Valuation", "name": "PS", "field": "PS", "class": "text-right", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Price to Sales Ratio" },
  { "label": "Valuation", "name": "MktCap To EBT", "field": "MKTEBT", "class": "text-right", "isSectorValue": false, "isPct": false, "mult": 1, "tooltip": "Market Capital to Earnings Before Tax Ratio" },
  { "label": "Valuation", "name": "ROE", "field": "ROE", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "Return on Equity" },
  { "label": "Growth", "name": "Rev 1Y Grw", "field": "REV_TTM__PCHG_1Y", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "Reveue Grw in past 1-Year" },
  { "label": "Growth", "name": "Earn 1Y Grw", "field": "NETINC_TTM__PCHG_1Y", "class": "text-right", "isSectorValue": false, "isPct": true, "mult": 1, "tooltip": "Earnings Grw, 1-Year" },
  // { "label": "Income Statement", "name": "EBITDA Margin", "field": "EBITDA_MGN", "class": "text-center", "isSectorValue": "true", "tooltip": "Earnings Before Taxes, Interest, Depreciation and Amortization Margin (EBITDA Margin)" },
  // { "label": "Balance Sheet", "name": "Assets", "field": "ASSETS", "class": "text-center", "isSectorValue": "true", "tooltip": "Total Assets" },
  // { "label": "Cashflow Statement", "name": "Dividends (TTM)", "field": "PMT_DIV_TTM", "class": "text-center", "isSectorValue": "true", "tooltip": "Dividends Paid Over the Trailing Twelve Months" },
  // { "label": "Statistics", "name": "Drawdowns", "field": "DRAWDN", "class": "text-center", "isSectorValue": "true", "tooltip": "DrawDown" },
  // { "label": "Operations", "name": "Revenues/Assets", "field": "TO_ASSET", "class": "text-center", "isSectorValue": "true", "tooltip": "Assets Turnover Ratio" },
  { "name": "", "tooltop": "Delete Ticker", "field": "delete", "isPremium": "Premium" }
]

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  maxHeight: 40,
  minHeight: 40,
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    // backgroundColor: '#020B4A',
    backgroundColor: 'hsl(235deg 59.62% 21.27%)',
  },
  '& .MuiTabs-scroller': {
    maxHeight: 40,
  }
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    whiteSpace: 'nowrap',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '.875rem',
    marginRight: theme.spacing(1),
    minHeight: 40,
    padding: '9px 16px',
    color: '#2a2d64c8',
    '&.Mui-selected': {
      // color: '#020B4A',
      color: 'hsl(235deg 59.62% 21.27%)',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(2, 14, 74, 0.32)',
    },
  }),
);

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    height: '24px',
    backgroundColor: 'transparent',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
      // backgroundColor: theme.palette.background.primary_light,
      // boxShadow: theme.shadows[1],
      icon: {
        color: theme.palette.background.primary,
      }
    },
    '&:active': {
      boxShadow: theme.shadows[1],
    },
  };
});

const stockTabs = (watch_tab_data) => {
  const { getStockTabs } = watch_tab_data || {};

  // const getTabData = d => {
  //   switch (d.type) {
  //     case dataConstants.STOCK_SECTION_TYPES.CHART:
  //       return d.tabData && d.tabData.length > 0 ? chart(undefined, d.tabData[0]).getChart : undefined;
  //     case dataConstants.STOCK_SECTION_TYPES.TICKER_TABLE:
  //       return d.tabData && d.tabData.length > 0 ? convertTickerTblFromData({ ...d.tabData[0], tickers: d.tabData[0].tickers ? JSON.parse(d.tabData[0].tickers) : d.tabData[0].tickers }) : undefined;
  //     case dataConstants.STOCK_SECTION_TYPES.TABLE_DATA:
  //       const tabData = d.tabData && d.tabData.length > 0 ? convertTblFromData(d.tabData) : undefined;
  //       return tabData;
  //     case "SERIES":
  //       return d?.tabData && d?.tabData?.length > 0 ? d?.tabData?.map(d => getSeries(undefined, d)) : undefined;
  //     default:
  //       return d.tabData;
  //   }
  // }

  return {
    getWatchTabs: getStockTabs && getStockTabs.length > 0 && getStockTabs?.map(d => ({
      ...d,
      // tabData: getTabData(d),
      settings: d.settings ? JSON.parse(d?.settings) : null,
    })),
  };
}

const Watchlist = ({ watch_tab_data, themeMode, pageLoading, system_watchlists, row_metrics, openDialog, activeWatchlist }) => {
  const router = useRouter();
  const theme = useTheme();
  const auth = useAuth();
  const { user } = auth || {}
  const { reloadUserInfo } = user || {}
  const isPremium = reloadUserInfo?.customAttributes && (JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PREMIUM" || JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PROFESSIONAL") ? true : false;
  const { getWatchTabs } = stockTabs(watch_tab_data) || {}
  const [value, setValue] = React.useState(0);
  const [status, setStatus] = React.useState(null);
  const [watchlists, setWatchlists] = React.useState([]);
  const [selectedWatchlist, setSelectedWatchlist] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  // const [openDialog, setOpenDialog] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const [userWatchMetrics, setUserWatchMetrics] = React.useState(row_metrics);

  const [columnGroups, setColumnGroups] = React.useState([])
  const [columns, setColumns] = React.useState([])

  // if (auth && !auth?.user && typeof window !== 'undefined' && !pageLoading) {
  //   router && router.push({
  //     pathname: '/auth',
  //     query: { from: router.asPath },
  //   });
  // }

  useEffect(() => {
    if (router && router?.query) {
      // setValue(parseInt(router?.query.list))
      setSelectedWatchlist(router?.query?.watchlist)
    }
  }, [router])

  // useEffect(async () => {
  //   setUserWatchMetrics(row_metrics)
  // }, [row_metrics])

  // const [wName, setWName] = React.useState('');
  // const [error, setError] = React.useState(false);
  // const [invalidChar, setInvalidChar] = React.useState('');

  // const handleWNameChange = (event) => {
  //   const inputValue = event.target.value;
  //   if (inputValue.length > 27) {
  //     setError(true);
  //     setInvalidChar('');
  //   } else {
  //     const invalid = inputValue.match(/[^a-zA-Z0-9_]/);
  //     if (invalid) {
  //       setError(true);
  //       setInvalidChar(invalid[0]);
  //     } else {
  //       setError(false);
  //       setInvalidChar('');
  //     }
  //   }
  //   setWName(inputValue);
  // };

  // const handleWatchlistDialog = () => { setOpenDialog(true); setAnchorEl(null); };

  // const handleDialogClose = () => { setOpenDialog(false); };

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    setStatus(null)
  };

  const handleSnackExited = () => {
    setMessageInfo(undefined);
    setStatus(null)
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const handleChange = (event, newValue) => {
  //   if (event?.target?.innerText?.includes('(')) {
  //     setSelectedWatchlist(event?.target?.innerText?.split("(")[0].trim())
  //     // window.history.pushState(null, null, `/watchlists?wl=${event?.target?.innerText?.split("(")[0].trim()}`);

  //   } else {
  //     setSelectedWatchlist(event?.target?.innerText)
  //   }
  //   setValue(newValue);
  //   window.history.pushState(
  //     null,
  //     null,
  //     `/watchlists/${event?.target?.innerText?.split("(")[0].trim()?.replace(" ", "_")}?list=${newValue}`
  //   );
  // };

  // const handleChangeIndex = (index) => {
  //   setValue(index);
  // };

  const handleSnack = (message) => () => {
    setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
  };

  const handleDeleteWatchlist = async () => {

    if (selectedWatchlist !== "" && user?.accessToken)
      await deleteWatchlist(selectedWatchlist, user?.accessToken).then(({ deleteWatchlist }) => {
        setStatus(deleteWatchlist?.status)
        if (deleteWatchlist?.status === "Success") {
          getAllWatchlists(value)
          setSnackPack((prev) => [...prev, { message: "Deleted Successfully", key: new Date().getTime() }]);
        } else {
          setSnackPack((prev) => [...prev, { message: "Error deleting watchlist", key: new Date().getTime() }]);
        }
      }).catch(error => {
        console.error('Error deleting watchlist:', error);
        setSnackPack((prev) => [...prev, { error, key: new Date().getTime() }])
        alert('An error occurred while deleting your watchlist. Please try again later.');
      });
  }

  // const getAllWatchlists = async (newList) => {
  //   setLoading(true);
  //   await getWatchlist(user?.accessToken).then(data => {
  //     // const { getWatchlist } = data || {}
  //     setLoading(false);
  //     setValue(newList ? data?.getWatchlist?.length - 1 : value ?? 0)
  //     setSelectedWatchlist(data?.getWatchlist[newList ? data?.getWatchlist?.length - 1 : value ?? 0]?.name ?? "")
  //     setWatchlists(data?.getWatchlist ?? [])
  //   }).catch(err => {
  //     console.log('caught it!', err);
  //     setLoading(false);
  //   });
  // }

  const handleUserWatchlist = async (name, tickers) => {
    if (tickers && tickers.length > 0) {
      setLoading(true);
      await getUserWatchlist(tickers)
        .then(data => {
          setSelectedWatchlist(name)
          setUserWatchMetrics(data?.getWatchlistMetrics)
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching watchlist:', error);
          setLoading(false);
        });
    }
  }

  const getAllWatchlists = async (newList) => {
    if (user?.accessToken) {
      setLoading(true);
      try {
        // const watchlistWithoutToken = await getWatchlist("");
        const watchlistWithToken = await getWatchlist(user.accessToken);

        // const mergedWatchlists = [
        //   ...watchlistWithToken?.getWatchlist,
        //   // ...watchlistWithoutToken?.getWatchlist,
        // ];

        // const sortedWatchlists = mergedWatchlists.sort((a, b) => a.isSystemDefault === b.isSystemDefault ? 0 : a.isSystemDefault ? -1 : 1);

        setLoading(false);
        // setValue(newList ? sortedWatchlists?.length - 1 : value ?? 0);
        // setSelectedWatchlist(sortedWatchlists[newList ? sortedWatchlists?.length - 1 : value ?? 0]?.name ?? "");
        setWatchlists(watchlistWithToken?.getWatchlist ?? []);
      } catch (error) {
        console.log('caught it!', error);
        setLoading(false);
      }
    }
  };

  const handleNewWatchlistName = async (new_list_name) => {
    setAnchorEl(null); setLoading(true);
    const emptyTicker = [];
    const notes = ""
    const description = ""
    const newList = true
    const _columns = "['ticker','tickername','sector','MKTCAP','REV_TTM','PCHG__7','PCHG__30','PCHG__365','PE','PS','ROE','REV_TTM__PCHG_3Y','DRAWDN']"
    await addToWatchlist(new_list_name, emptyTicker, notes, description, _columns, user?.accessToken).then(({ addToWatchlist }) => {
      if (addToWatchlist?.status === "Success") {
        getAllWatchlists(newList)
        router.push(`/watchlists/u/${new_list_name}`)
      }
      setLoading(false);
    }).catch(err => {
      console.log('caught it!', err);
      setLoading(false);
    });
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setColumns(prevValue => {
      const newValue = [...prevValue];
      const [itemToMove] = newValue.splice(oldIndex, 1);
      newValue.splice(newIndex, 0, itemToMove);
      return newValue;
    });
  };

  // useEffect(async () => {
  //   setValue(0)
  //   if (watchlists && watchlists.length > 0)
  //     setSelectedWatchlist(watchlists[0]?.name)
  // }, [])

  const _get_watchlist_ = async (accessToken) => {
    if (accessToken) {
      await getWatchlist(accessToken).then(data => {
        // setValue(0)
        // setSelectedWatchlist(data?.getWatchlist[0]?.name ?? "")
        setWatchlists(data?.getWatchlist ?? [])
      });
    }
  }

  useEffect(() => {
    _get_watchlist_(user?.accessToken)
    // if (user?.accessToken) {
    //   await getWatchlist(user?.accessToken).then(data => {
    //     // setValue(0)
    //     // setSelectedWatchlist(data?.getWatchlist[0]?.name ?? "")
    //     setWatchlists(data?.getWatchlist ?? [])
    //   });
    // }
  }, [user?.accessToken])

  useEffect(() => {
    // const reqCols = [{ "name": "Ticker", "field": "ticker", "urlField": "ticker", "isPremium": "Premium" },
    // { "name": "Name", "field": "name", "class": "td-color", "urlField": "ticker", "isPremium": "Premium" }]
    // // { "label": "Price", "name": "Price", "field": "PRICE", "class": "text-center", "isSectorValue": "true", "tooltip": "Price" }]
    // const _mainHeadCols = getWatchTabs && getWatchTabs.length > 0 ? getWatchTabs[0]?.settings?.mainHeadCols : mainHeadCols
    // const _cols = getWatchTabs && getWatchTabs.length > 0 ? getWatchTabs[0]?.settings?.cols : cols
    // setColumnGroups(_mainHeadCols)
    const _cols = "['ticker','tickername','sector','MKTCAP','REV_TTM','PCHG__7','PCHG__30','PCHG__365','PE','PS','ROE','REV_TTM__PCHG_3Y','DRAWDN']"
    setColumns(activeWatchlist && activeWatchlist?.columns ?
      JSON.parse(activeWatchlist.columns?.replace(/'/g, '"'))?.map(field => dataConstants.DEFAULT_TBL_COLS?.find(item => item?.field === field)) :
      JSON.parse(_cols?.replace(/'/g, '"'))?.map(field => dataConstants.DEFAULT_TBL_COLS?.find(item => item?.field === field)))
  }, [watch_tab_data])

  useEffect(() => {
    getAllWatchlists(false)
  }, [user?.accessToken]);

  return (
    // <NoData noData={!(name && Object.keys(data) && Object.keys(data).length > 0)}>
    <div className="watchlist-body sum-section">
      {/* <Box component="div" className="row sum-r">
        <Box component="div" className="col-md-12">
          <Box component="div" className="fund-latest" >
            <Box sx={{ flexGrow: 1, my: 1 }}>
              <AppBar position="static" sx={{ p: 1, pb: 1.5, borderRadius: '5px', top: 0, bgcolor: themeMode === 'dark' ? 'background.default' : '#f8f9fa', boxShadow: '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)' }} elevation={0}>
                <Container maxWidth="lg" sx={{ mb: 0 }}>
                  <Box component="div" className="fund-info p-0">
                    <Box
                      sx={{
                        display: 'flex', alignItems: 'end',
                        '& .hyper-link': { display: 'none', fontSize: '1.1rem' }, '&:hover .hyper-link': { display: 'inline-block' },
                        '&:hover .hyper-share': { display: 'none' },
                        '&:hover .fund-name': { borderBottom: '1px dotted' }, '& .hyper-link:hover ': { color: '#174c86', cursor: 'pointer' },
                        '.fund-name': { borderBottom: '1px solid transparent' },
                      }}>
                      <Typography className="fund-name" variant="h1" sx={{ color: 'text.link', fontSize: '1.5rem', fontWeight: '400', mr: 2 }}>
                        {'Watchlist'}{watchlists && watchlists.length > 0 ? `s (${watchlists.length})` : null}
                      </Typography>
                    </Box>
                  </Box>
                </Container>
              </AppBar>
              <Container maxWidth="lg">
                <Box component="nav"
                  className="bread-container"
                  sx={{
                    mt: 1,
                    padding: '8px',
                    borderRadius: '5px',
                  }}>
                  <Box sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' }, alignItems: 'center', justifyContent: 'space-between' }}>
                    <Breadcrumbs  >
                      <Link prefetch={false} color="inherit" href={`${dataConstants.NAVS.FUNDS}`} >
                        <StyledBreadcrumb
                          label="Home"
                          icon={<PlaylistAddCheckRoundedIcon sx={{ '&.MuiChip-icon': { color: 'text.very_light_desc', fontSize: '1.1rem' }, color: 'text.link' }} fontSize="small" />}
                          sx={{ color: 'text.very_light_desc', fontSize: '.78rem' }}
                        />
                      </Link>
                      <StyledBreadcrumb
                        label={`Your Lists`}
                        className={'bread-bg-blue'}
                        sx={{ backgroundColor: '#f2f2f2', fontSize: '.78rem' }}
                      />
                    </Breadcrumbs>
                    <div>
                      <IconButton
                        id="fade-button"
                        aria-controls={openMenu ? 'fade-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                        onClick={handleMenuClick}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="fade-menu"
                        MenuListProps={{
                          'aria-labelledby': 'fade-button',
                        }}
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleMenuClose}
                        TransitionComponent={Fade}
                      >
                        <MenuItem onClick={handleMenuClose}>
                          <ListItemIcon>
                            <DownloadRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Download as CSV
                          </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleMenuClose}>
                          <ListItemIcon>
                            <EditRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Rename
                          </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleDeleteWatchlist}>
                          <ListItemIcon>
                            <DeleteOutlineRoundedIcon fontSize="small" />
                          </ListItemIcon>
                          <Typography variant="inherit" noWrap fontSize="small" >
                            Delete "{selectedWatchlist}"
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </div>
                  </Box>
                </Box>
              </Container>
            </Box >
          </Box>
        </Box>
      </Box> */}
      <Container maxWidth="xxl" sx={{ p: '0 !important' }}>
        {/* <TabContext value={value}> */}
        <Box component="div" className="row sum-r f-hold-r" sx={{}}>
          <AppBar
            position="relative"
            sx={{
              zIndex: 110,
              // top: '1.3rem', p: 1, pb: 1.5, borderRadius: '5px',
              bgcolor: themeMode === 'dark' ? 'background.default' : '#f8f9fa',
              boxShadow: '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)'
            }} elevation={0}
          >
            <Container maxWidth="xl">
              <Box component="nav"
                className="bread-container"
                sx={{
                  mt: 1, py: '8px', borderRadius: '5px',
                }}>
                <Breadcrumbs>
                  <Link prefetch={false} color="inherit" href={`${dataConstants.NAVS.HOME}`} >
                    <StyledBreadcrumb
                      label="Home"
                      icon={<HomeRoundedIcon sx={{ '&.MuiChip-icon': { color: 'text.very_light_desc', fontSize: '1.1rem' }, color: 'text.link' }} fontSize="small" />}
                      sx={{ color: 'text.very_light_desc', fontSize: '.78rem', cursor: 'pointer', '& .MuiChip-label': { pr: 0, lineHeight: 1 } }}
                    />
                  </Link>
                  <Link prefetch={false} color="inherit" href={`/watchlists`} >
                    <StyledBreadcrumb
                      label={`Watchlists`}
                      className={'bread-bg-blue'}
                      sx={{ color: 'text.very_light_desc', fontSize: '.78rem', cursor: 'pointer', '& .MuiChip-label': { p: 0, lineHeight: 1 } }}
                    />
                  </Link>
                  <StyledBreadcrumb
                    label={selectedWatchlist}
                    className={'bread-bg-blue'}
                    sx={{ fontSize: '.78rem', '& .MuiChip-label': { px: 0, lineHeight: 1 } }}
                  />
                </Breadcrumbs>
              </Box>
              {/* <Box sx={{
                  // '& .MuiTabs-root .MuiTabs-scrollButtons': {
                  //   // position: 'absolute',
                  //   py: .5,
                  //   opacity: 1,
                  //   zIndex: 99,
                  // },
                  // '& .MuiTabs-root .MuiTabs-scrollButtons.Mui-disabled': { display: 'none' },
                  '& .MuiButtonBase-root.MuiTabScrollButton-root:first-child': {
                    color: '#020e4a',
                    left: 0,
                    background: 'linear-gradient(to right, rgb(247, 248, 250) 20%,rgba(33,33,33,0) 80%) !important',
                    justifyContent: 'flex-start',
                  },
                  '& .MuiButtonBase-root.MuiTabScrollButton-root:last-child': {
                    color: '#020e4a',
                    right: 0,
                    background: 'linear-gradient(to left, rgb(247, 248, 250) 20%,rgba(33,33,33,0) 80%) !important',
                    justifyContent: 'flex-end',
                  }
                }}>
                  <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="user watchlists"
                    variant="scrollable"
                    scrollButtons="auto"
                    // allowScrollButtonsMobile
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        '&.Mui-disabled': { opacity: 0.3 },
                      },
                    }}
                  >
                    {watchlists && watchlists.length > 0 ?
                      watchlists?.map(d => <StyledTab key={getRandomStr(3)} label={<>{d?.name}&nbsp; ({JSON.parse(d?.tickers)?.length})</>} />)
                      : <StyledTab label="My Watchlist" />}
                    <AddNewWatchlist handleNewWatchlistName={handleNewWatchlistName} />
                  </StyledTabs>
                </Box> */}
              <Box sx={{ mb: .7, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Typography color="primary" variant="h1" sx={{ mx: 0, fontWeight: 500, fontSize: '1.25rem', lineHeight: '1.6', letterSpacing: '0.0075em' }}>
                  Watchlist: {selectedWatchlist}
                </Typography>
                <AddNewWatchlist
                  handleNewWatchlistName={handleNewWatchlistName}
                  dataEventFrom={"system-watchlists"}
                  isLoggedin={auth && auth?.user && auth?.user?.accessToken}
                />
              </Box>
            </Container>
          </AppBar>
          {/* <SwipeableViews
          // axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          // index={value}
          // onChangeIndex={handleChangeIndex}
          > */}
          {/* {watchlists && watchlists.length > 0 && watchlists.map((d, i) => {
                  return ( */}
          {/* <TabPanel value={value} index={value} dir={theme.direction} sx={{ px: 0 }}> */}
          <Container maxWidth="xl" sx={{ width: '100%', }}>
            <Box sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}>
              <SwipeableEdgeDrawer
                text={`View All Your Watchlists.`}
                content={<UserWatchlists
                  handleUserWatchlist={handleUserWatchlist}
                  system_watchlists={system_watchlists}
                  user_watchlists={watchlists}
                  selectedWatchlist={selectedWatchlist}
                  tickers={watchlists && watchlists.length > 0 && watchlists[value] ? watchlists[value]?.tickers : ""}
                  isSystemDefault={activeWatchlist?.isSystemDefault ?? true}
                  sx={{ display: { xs: 'block', sm: 'none', md: 'none' } }}
                />}
              />
            </Box>
            <Grid container rowSpacing={2} columnSpacing={2}>
              <UserWatchlists
                handleUserWatchlist={handleUserWatchlist}
                system_watchlists={system_watchlists}
                user_watchlists={watchlists}
                selectedWatchlist={selectedWatchlist}
                tickers={watchlists && watchlists.length > 0 && watchlists[value] ? watchlists[value]?.tickers : ""}
                isSystemDefault={activeWatchlist?.isSystemDefault ?? true}
                sx={{ display: { xs: 'none', sm: 'block', md: 'block' } }}
              />
              <Grid item xs={12} sm={9} md={9.5} sx={{}}>
                {auth && !auth?.user && pageLoading ?
                  <Box component="div" sx={{ height: '47vh', width: '100%', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mx: 'auto' }}>Fetching Your Watchlist...</Typography>
                  </Box> :
                  <WatchlistTable
                    mainHeadCols={columnGroups}
                    cols={columns}
                    row_metrics={row_metrics}
                    value={value}
                    isSystemDefault={true}
                    tickers={activeWatchlist && activeWatchlist?.tickers && activeWatchlist?.tickers !== "" ? JSON.parse(activeWatchlist?.tickers) : []}
                    disable={watchlists && watchlists.length > 0 ? false : true}
                    isPremium={isPremium}
                    openDialog={openDialog}
                    selectedWatchlist={selectedWatchlist}
                    selectedWatchlistDesc={activeWatchlist?.description ?? ""}
                    selectedWatchlistNotes={activeWatchlist?.notes ?? ""}
                    accessToken={user?.accessToken}
                    setStatus={setStatus}
                    getAllWatchlists={getAllWatchlists}
                    deleteWatchlist={handleDeleteWatchlist}
                    refresh={loading}
                    setColumnGroups={setColumnGroups}
                    setColumns={setColumns}
                    onSortEnd={onSortEnd}
                    handleSaveColumns={() => { }}
                    tableName={selectedWatchlist &&
                      <Box component='div' sx={{ pt: 0, mr: 'auto', mb: activeWatchlist?.description && activeWatchlist?.description !== "" ? 0 : 1 }}>
                        {selectedWatchlist &&
                          <Typography color="primary" variant="h6" sx={{ mx: 2, fontWeight: 500, fontSize: '1rem', lineHeight: '1.6', letterSpacing: '0.0075em', textTransform: 'capitalize' }}>
                            {selectedWatchlist}
                          </Typography>}
                        {activeWatchlist?.description &&
                          <Typography variant="body2" component="div" sx={{ mx: 2, mb: 1.7, fontWeight: 500, fontSize: '.875rem', color: 'rgb(96, 111, 123)' }}>
                            {activeWatchlist?.description}
                          </Typography>}
                      </Box>}
                  />}
              </Grid>
            </Grid>
            {/* {watchlists[value]?.tickers.includes(`\"`) ? */}
          </Container>
          {/* </TabPanel> */}
          {/* ) */}
          {/* })} */}
          {/* </SwipeableViews> */}
        </Box>
        {/* :null } */}
        {/* </TabContext> */}
      </Container>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        open={open}
        autoHideDuration={1000}
        onClose={handleSnackClose}
        TransitionProps={{ onExited: handleSnackExited }}
        message={messageInfo ? messageInfo.message : undefined}
        action={
          <React.Fragment>
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{ p: 0.5 }}
              onClick={handleSnackClose}
            >
              <CloseRoundedIcon />
            </IconButton>
          </React.Fragment>
        }
      />
      {/* <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{`Create a new list`}</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { mt: 1, width: '40ch' },
            }}
            noValidate
            autoComplete="off"
          >
            <TextField
              error={error}
              required
              id="list-required"
              label="New list name"
              helperText={
                error
                  ? invalidChar
                    ? `Invalid character '${invalidChar}' found.`
                    : 'String too long.'
                  : 'Field is required.'
              }
              value={wName}
              onChange={handleWNameChange}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 1, pt: 0 }}>
          <Button sx={{ textTransform: 'none', mr: 2 }} onClick={handleDialogClose}>Cancel</Button>
          <Button variant="contained" sx={{ textTransform: 'none', mr: 2 }} onClick={() => handleNewWatchlistName(wName)} disabled={wName === "" || error}>Create</Button>
        </DialogActions>
      </Dialog> */}
    </div >
    // </NoData >
  );
}

export async function getStaticPaths() {
  const { getWatchlist: system_watchlists } = await getWatchlist("") || {};
  return {
    paths: system_watchlists?.map(list => ({
      params: { watchlist: list.name },
    })),
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params, tabCode = "WATCH", preview = false }) {
  const { getWatchlist: system_watchlists } = await getWatchlist("") || {};
  const foundList = system_watchlists?.find(d => d.name === params.watchlist) || {}
  const tickers = foundList?.tickers && foundList?.tickers !== "" ? JSON.parse(foundList?.tickers) : ""
  const { getWatchlistMetrics: row_metrics } = await getUserWatchlist(tickers) || {}
  const watch_tab_data = (await getStockTabs(undefined, tabCode, preview)) || [];
  const meta_tags = (await getPageMetaTags(`/watchlist`, false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      meta_tags: getMetaTags?.tags || null,
      // watch_tab_data: watch_tab_data?.getStockTabs[0] || [],
      watch_tab_data,
      system_watchlists,
      row_metrics,
      activeWatchlist: foundList,
    },
    revalidate: dataConstants.REVALIDATE_IN.ONE_DAY,
    // notFound: process.env.NEXT_PUBLIC_URL === 'https://dev.grufity.com' ? false : true,
  }
}

export default needPremium(Watchlist);
